<template>
  <div>
    <el-dialog
      title="Добавление секции"
      :visible.sync="$store.getters.footerSectionsCreateDialog"
      width="60%"
      :before-close="closePopup" 
    >

      <el-form ref="form" label-width="120px" id="uploadForm" name="uploadForm">
        <el-form-item label="Название">
          <el-input v-model="title"></el-input>
        </el-form-item>
        <el-form-item label="Сортировка">
          <el-input type="number" v-model="sort"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePopup">Отмена</el-button>
        <el-button type="primary" :disabled="disableButton" @click="saveIcon">Добавить</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { SETPRELOADER_STATE } from '../../store/mutation-types.js'

export default {
  data() {
    return {
      title: '',
      sort: null,
    }
  },
  computed: {
    disableButton() {
      return !(this.title && this.sort)
    }
  },
  methods: {
    saveIcon() {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true)
      }, 400)

      const data = {
        title: this.title,
        sort: +this.sort,
      }

      axios.post('/page/footer-section', data).then((response) => {
        this.$emit('create-section', response.data)
        this.$store.commit('openFooterSectionCreateDialogPopup',false)
      }).finally(() => {
        clearTimeout(loader)
        this.$store.commit(SETPRELOADER_STATE, false)
      })
    },
    handleClose() {
      this.title = '';
      this.sort = null;
    },
    closePopup() {
      this.$store.commit('openFooterSectionCreateDialogPopup',false)

      this.title = '';
      this.sort = null;
    }
  }
}
</script>